namespace advisorop.components.common {
    
    class AssignCuRtgController {
        account: domains.IAccount;
        showHeader: any = "yes";
        rtgs: Array<domains.IAccountGroup>;

        selInvestor: domains.IInvestor;
        selRTG: domains.IAccountGroup;
        selHousehold: domains.IHousehold;
        isHouseholdFormVisible: boolean = false;
        advisoryFirmId: number;
        assigningRTGLadda: boolean = false;
        formDataChanged: any;

        static $inject = ["advisorService", "accountApi"];
        constructor(private advisorService: services.AdvisorService,
            private accountApi: services.AccountApi) {
        }

        //loadAccount(accountId: number) {
        //    this.accountApi.getById(accountId)
        //        .then(data => {
        //            this.account = data.data;
        //        })
        //        .catch(error => {
        //            toastr.error("Error " + error.status + " " + error.data);
        //        });

        //};

        showMainAccordion: boolean = false;

        assignAccountToRTG(): void {
            this.assigningRTGLadda = true;

            let link: domains.IAccountGroupAccount = {};

            //console.log("SEL RTG assigning to account");
            //console.log(this.selRTG);

            if (this.account) {
                link.accountId = this.account.id;
            } else {
                link.accountId = this.accountApi.paccount.id;
            }
            link.id = 0;
            //we don't need individual since each individual in the same household will
            //get the same RTG !!!!
            //this.selInvestor.id;
            link.accountGroupId = this.selRTG.id;

            this.advisorService.assignAccountToRTG(link)
                .then(data => {
                    // set the account if it was passed in, otherwise set the global account in the service
                    if (this.account) {
                        this.account.rtgs = data.data;
                    } else {
                        this.accountApi.paccount.rtgs = data.data;
                    }
                    this.selInvestor = null;
                    this.showMainAccordion = false;
                    this.selRTG = null;
                    // callback to calling controller
                    //console.log("assign-cu-rtg calling formdatachanged callback");
                    this.formDataChanged();
                })
                .catch(data => {
                    toastr.error("RTG Error " + data.status + " " + data.data);
                    this.assigningRTGLadda = false;
                })
                .finally(() => {
                    this.assigningRTGLadda = false;
                });
        };

        refreshAccountRTGs(): void {
            this.accountApi.getById(this.account.id)
                .then(data => {
                    if (this.account) {
                        this.account.rtgs = data.data.rtgs;
                    } else {
                        this.accountApi.paccount.rtgs = data.data.rtgs;
                    }
                    // callback to calling controller
                    this.formDataChanged();
                })
                .catch(data => {
                    console.error("Refresh RTGs error: " + data.status + " " + data.data);
                })
        }
        
        showHideHouseholdForm(): void {
            if (this.isHouseholdFormVisible) {
                this.isHouseholdFormVisible = false; // hide
            }
            else {                
                this.loadInvestorHouseholds(this.selInvestor);
                this.isHouseholdFormVisible = true;
            }
        };

        households: Array<domains.IHousehold> = [];

        loadInvestorHouseholds(investor: domains.IInvestor): void {

            if (!investor)
                return;

            //.filter((value, index, array) => { return value.id === this.account.advisoryFirm.id });
            this.advisorService.getAllHouseholdsByInvestor(investor.id)
                .success((data) => {
                    this.households = data;

                    //console.log("Households list");
                    //console.log(this.households);

                    //this is just temp. its not good will see with fehim about this...

                    investor.households = this.households.filter((v, i, a) => { return v.advisoryFirmId === this.advisoryFirmId });

                    //console.log("FILTERED  hosuehopld");
                    //console.log(investor.households);
                })
                .error((data, status) => {
                    toastr.error("Household Error " + status + " " + data);
                });
        };

        selectDefaultOption: boolean = false;


        

        loadInvestorsRTG(investor: domains.IInvestor, rtg: domains.IAccountGroup): void {
            //console.log("EVENT RTG");
            //console.log(rtg);
            this.isHouseholdFormVisible = false;
            this.selInvestor = investor;
            this.selRTG = rtg;
            this.showMainAccordion = !this.showMainAccordion;

            this.advisorService.getRTGByInvestor(this.selInvestor.id)
                .then( data => {
                    //console.log(data.data);
                    if (this.account) {
                        this.rtgs = data.data.filter((v, i, a) => { return v.advisoryFirmId === this.account.advisoryFirm.id });
                    } else {
                        this.rtgs = data.data.filter((v, i, a) => { return v.advisoryFirmId === this.accountApi.paccount.advisoryFirm.id });
                    }
                })
                .catch( data => {
                    toastr.error("RTG Error " + data.status + " " + data.data);
                });
        };

        householdCu(household: domains.IHousehold): void {
            this.selHousehold = household;
        };
        
        rtgCu(newRtg: domains.IAccountGroup): void {
            //console.log("assignCuRtg.rtgCu fired", newRtg);
            this.selRTG = newRtg;
            if (this.selRTG) {
                this.selRTG.id = newRtg.rtq.accountGroupId;
                this.assignAccountToRTG();
            }
            //this.loadInvestorsRTG(this.selInvestor, this.selRTG);
            this.refreshAccountRTGs();
        };

        finish(): void {
            window.history.back();
        };

        $onInit(): void {  
            if (!this.account) {
                //console.log("assign-cu-rtg -- USING SERVICE ACCOUNT OBJECT");
                this.account = this.accountApi.paccount;
            }
            this.formDataChanged();
        }

        $onChanges(evt): void {            
            for (var key in evt) {
                if (key === "account") {
                    if (this.account && this.account.id > 0) {
                        //console.log("Loading account..." + this.accountId);
                        //this.loadAccount(this.accountId);
                        this.advisoryFirmId = this.account.advisoryFirm.id;
                    } else if (this.accountApi.paccount.id > 0) {
                        this.advisoryFirmId = this.accountApi.paccount.advisoryFirm.id;
                    }
                    this.formDataChanged();
                }
            }
        }        
    }


    class AssignCuRtg implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.controller = AssignCuRtgController;
            this.controllerAs = "vm";
            this.bindings = {
                account: "<",
                showHeader: "@",
                formDataChanged: "&"
            };
            this.templateUrl = "spa/shared/common/assign-cu-rtg.html";
        }        
    }
    angular.module(Constants.APP).component("assignCuRtg", new AssignCuRtg());    
}